// extracted by mini-css-extract-plugin
export default {"btns":"Devices_btns__Op6Cu"};